import ReactHtmlParser from 'react-html-parser';

import PropTypes from 'prop-types';

const LoginFooter = ({ data }) => {
  const { widgetFooterContent } = data;

  return <div className="widget-footer">{ReactHtmlParser(widgetFooterContent.richText)}</div>;
};

LoginFooter.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired
};

export default LoginFooter;
